import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { DirtyComponent } from 'projects/shared/src/helpers/CanDeactivate/dirty-component';
import { Action } from '../../../models/fraud-monitoring-tasks/AvailableActions';
import { FraudTaskService } from '../../../services/fraud-task.service';
import { TaskActionData } from '../../../models/fraud-monitoring-tasks/TaskActionData';
import { CustomValidator } from 'projects/shared/src/helpers/custom.validator';
import { SwalService } from 'projects/shared/src/services/swal.service';

export interface DialogData {
  action: Action;
  taskId: number
}

@Component({
  selector: 'app-publish-monitored-fraud-task',
  standalone: false,
  templateUrl: './publish-monitored-fraud-task.component.html'
})
export class PublishMonitoredFraudTaskComponent extends DirtyComponent implements OnInit {
  loading = false;
  override formGroup: FormGroup = new FormGroup({});

  constructor(
    override dialogRef: MatDialogRef<PublishMonitoredFraudTaskComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    private service: FraudTaskService,
    translate: TranslateService,
    private swalService: SwalService
  ) {
    super(translate);
  }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      publicFraudCaseName: [null, [Validators.required, CustomValidator.noWhiteSpace, Validators.minLength(2), Validators.maxLength(150)]],
    });
  }

  saveRecord() {
    if (this.formGroup.valid) {
      this.loading = true;
      const data = {
        actionId: this.data.action.actionId,
        taskId: this.data.taskId,
        nextStatus: this.data.action.nextStatus,
        publicFraudCaseName: this.formGroup.controls['publicFraudCaseName'].value
      } as TaskActionData;
      this.service.changeTaskStatus(data).subscribe((res: any) => {
        this.loading = false;
        this.dialogRef.close(true);
        Swal.fire({
          title: this.translate.instant('swalMsg.fraudCasePublishedSuccessfully'),
          imageUrl: './assets/images/icons/success.svg',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      }, (error: any) => {
        this.loading = false;
        this.handleErrors(error.detail);
      });
    } else {
      this.formGroup.markAllAsTouched();
    }
  }

  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      this.swalService.swalFailed(error.Error);
    });
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }
}
